module.exports = __webpack_public_path__ + "static/media/checklist.6a583f0c.svg";